import {
  Box,
  Breadcrumbs,
  Grid2,
  Tab,
  Tabs,
  Typography,
  Paper,
  Divider,
  alpha,
  Stack,
} from '@mui/material';
import { useEffect } from 'react';
import { withRouter } from 'react-router';
import ConsultantDetails from './consultant-view/ConsultantDetails';
import ConsultantDocuments from './consultant-view/ConsultantDocuments';
import { Link } from 'react-router-dom';
import ConsultantFacilities from './consultant-view/ConsultantFacilities';
import { userCats } from '../../../helpers/appstate';
import {
  ChevronRight,
  FolderOutlined,
  BusinessOutlined,
} from '@mui/icons-material';

const ConsultantViewScreen = withRouter(({ props }) => {
  const { userCategory, location, history } = props;
  const consultantUserId = location?.pathname?.split('/')[2];
  const searchParams = new URLSearchParams(location?.search);
  const tab = searchParams.get('tab') || '';

  const tabs = [
    {
      value: 'documents',
      label: 'Documents',
      icon: <FolderOutlined sx={{ fontSize: 18 }} />,
      component: () => (
        <ConsultantDocuments userCategory={userCategory} consultantUserId={consultantUserId} />
      ),
    },
    {
      value: 'facility',
      label: 'Facilities',
      icon: <BusinessOutlined sx={{ fontSize: 18 }} />,
      component: () => <ConsultantFacilities consultantUserId={consultantUserId} />,
    },
  ];

  const tabIndex = tabs?.findIndex((x) => x.value === tab);
  const activeTabIndex = tabIndex !== -1 ? tabIndex : 0;

  useEffect(() => {
    handleIniSearchParam();
  }, []);

  const handleIniSearchParam = () => {
    if (!tab) {
      const newParam = new URLSearchParams(searchParams);
      newParam.set('tab', tabs[0]?.value);
      history.replace({ search: newParam.toString() });
    }
  };

  const handleTabChange = (ev, val) => {
    const newParam = new URLSearchParams();
    newParam.set('tab', tabs[val]?.value);
    history.push({ search: newParam.toString() });
  };

  return (
    <Box sx={{ bgcolor: '#F4F6F8', minHeight: '100vh', p: { xs: 1, md: 3 } }}>
      {/* BREADCRUMBS HEADER */}
      <Box sx={{ mb: 3, px: 1 }}>
        {(userCategory === userCats.EDM || userCategory === userCats.REGULATOR) && (
          <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ mb: 1 }}>
            <Link to="/consultants" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body2"
                sx={{
                  color: 'primary.main',
                  fontWeight: 600,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Consultants
              </Typography>
            </Link>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              Consultant Profile
            </Typography>
          </Breadcrumbs>
        )}
      </Box>

      <Grid2 container spacing={3} sx={{ alignItems: 'flex-start' }}>
        {/* LEFT PANEL: Consultant Profile Card */}
        <Grid2 size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: '20px',
              border: '1px solid',
              borderColor: 'divider',
              overflow: 'hidden',
              position: 'sticky',
              top: '20px',
              bgcolor: '#fff',
              height: 'fit-content',
            }}
          >
            <Box sx={{ p: 0 }}>
              <ConsultantDetails props={props} consultantUserId={consultantUserId} />
            </Box>
          </Paper>
        </Grid2>

        {/* RIGHT PANEL: Tabbed Content Area */}
        <Grid2 size={{ lg: 8, md: 8, sm: 12, xs: 12 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: '20px',
              border: '1px solid',
              borderColor: 'divider',
              minHeight: '75vh',
              display: 'flex',
              flexDirection: 'column',
              bgcolor: '#fff',
              overflow: 'hidden',
            }}
          >
            <Box sx={{ px: 2, pt: 1 }}>
              <Tabs
                value={activeTabIndex}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.875rem',
                    minHeight: 56,
                    color: 'text.secondary',
                    '&.Mui-selected': { color: 'primary.main' },
                  },
                }}
              >
                {tabs?.map((item, idx) => (
                  <Tab key={idx} label={item.label} icon={item.icon} iconPosition="start" />
                ))}
              </Tabs>
            </Box>

            <Divider />

            <Box sx={{ p: { xs: 2, md: 3 }, flexGrow: 1, bgcolor: alpha('#F4F6F8', 0.2) }}>
              {tabs[activeTabIndex]?.component()}
            </Box>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
});

export default ConsultantViewScreen;
